<div class="row">
   
</div>

<div class="row">
    <div class="col-16">
        <div class="bottom-20"><b>Enrollment has been saved!</b></div>
    </div>
</div>
<div class="row">
    <div class="col-16">
        <div class="bottom-20">
            Enrollment Confirmation # {{enrollment.CONF}}
        </div>
    </div>
</div>
<div class="row">
    <div class="col-24">
        <button class="button primary" (click)="completeEnrollment()">Click here to complete this enrollment</button>
        <button class="button primary" (click)="enrollNewClient()">Enroll new client</button>
    </div>
</div>
